import ID from '../../../../types/id';
import { ConsentRequest } from '../../../../interfaces/consent-request';
import ConsentApprovalStatus from '../../../../interfaces/consent-approval-status';
import ConsentRequiredStatus from '../../../../interfaces/consent-required-status';
import { User } from '../../../../interfaces/user';
import { gql } from 'apollo-angular';
import ConsentRequestApproval from '../../../../interfaces/consent-request-approval';

type RequestWithApprovalsResponse = {
  getConsentRequest: ConsentRequest;
  getConsentApprovalStatuses: ConsentApprovalStatus[];
  getConsentRequiredStatuses: ConsentRequiredStatus[];
  me: User;
};
type RequestWithApprovalsVariables = {
  id: ID;
};
export const APPROVAL_FIELDS = `
id
investor_sent_date
fund_approval_date
investor_report_comment
consent_required_status_id
current_percent_approved
current_percent_denied
consent_request_id
percent_approval_required
fund {
  id
  name
}
certificatedOutlet{
  id
  organization{
    id
    name
  }
}
consentRequestInvestorApprovals {
  id
  consent_approval_status_id
  owned_percentage
  approval_date
  notes
  organization {
    id
    name
  }
}`;
export const GET_REQUEST_WITH_APPROVALS = gql<
  RequestWithApprovalsResponse,
  RequestWithApprovalsVariables
>`
  query getRequestWithApprovals($id: ID!) {
    getConsentRequest(id: $id) {
      id
      received_date
      timing_date
      is_urgent_flag
      urgency_note
      project {
        id
        name
        developer {
          id
          name
        }
        participants(withRole: ["Sponsor"]){
          id
          person {
            id
            name
          }
          role {
            id
            name
          }
          organization {
            id
            name
          }
          sponsor {
            id
            name
            is_repeat
            nickname
          }
        }
      }
      details
      consentRequestType {
        id
        request_type
      }
      consentRequestApprovals {
       ${APPROVAL_FIELDS}
      }
    }
    getConsentApprovalStatuses {
      id
      is_approval
      status
    }
    getConsentRequiredStatuses {
      id
      required_status
    }
    me {
      id
      permissionsForResource(resourceType: CONSENTREQUESTAPPROVAL) {
        _create
        _read
        _delete
        _edit
        authorized_fields
      }
    }
  }
`;

export type RefreshApprovalsResponse = {
  getConsentRequestApprovals: ConsentRequestApproval[];
};
export type RefreshApprovalsVariables = {
  consent_request_id: ID;
};
export const REFRESH_APPROVALS = gql<
  RefreshApprovalsResponse,
  RefreshApprovalsVariables
>`
    query refreshApprovals($consent_request_id:ID!) {
        getConsentRequestApprovals(consent_request_id:$consent_request_id){
            ${APPROVAL_FIELDS}
        }
    }
`;
export type UpdateConsentInvestorApprovalsInput = {
  id: ID;
  consent_approval_status_id: ID | null;
  approval_date: ID | null;
  notes: string | null;
};
type InvestorApprovalHasMany = {
  update: UpdateConsentInvestorApprovalsInput[];
};

export type UpdateConsentRequestApprovalInput = {
  consent_required_status_id: ID | null;
  investor_sent_date: string | null;
  fund_approval_date: string | null;
  investor_report_comment: string | null;
  percent_approval_required: number | null;
  consentRequestInvestorApprovals: InvestorApprovalHasMany;
};

export type UpdateConsentRequestApprovalResponse = {
  updateConsentRequestApproval: ConsentRequestApproval;
};
export type UpdateConsentRequestApprovalVariables = {
  id: ID;
  input: UpdateConsentRequestApprovalInput;
};
export type UpdateConsentApprovalTuple = [
  ID,
  UpdateConsentRequestApprovalInput
];
export const UPDATE_APPROVAL = gql<
  UpdateConsentRequestApprovalResponse,
  UpdateConsentRequestApprovalVariables
>`
  mutation updateConsentRequestApproval(
    $id: ID!
    $input: UpdateConsentRequestApprovalInput!
  ) {
    updateConsentRequestApproval(id: $id, input: $input) {
      id
    }
  }
`;
